(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[894],{

/***/ 38248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sg": function() { return /* reexport */ Column; },
  "OO": function() { return /* reexport */ ContentContainer; },
  "hU": function() { return /* reexport */ IconButton; },
  "X2": function() { return /* reexport */ Row; },
  "Sn": function() { return /* reexport */ StyledButton; },
  "rg": function() { return /* reexport */ StyledCard; },
  "Bw": function() { return /* reexport */ StyledCta; },
  "Fy": function() { return /* reexport */ StyledInput; },
  "x9": function() { return /* reexport */ StyledScreen; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(92909);
;// CONCATENATED MODULE: ./components/styles/IconButton.tsx


var IconButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "IconButton",
  componentId: "sc-1hluxaq-0"
})(["background-color:transparent;border:none;border-radius:100px;display:flex;padding:6px;cursor:pointer;width:fit-content;:hover{background-color:", ";}"], function (props) {
  return "".concat(props.theme.colors.text.primary).concat(constants/* BUTTON_HIGHLIGHT_HEX_OPACITY_SUFFIX */.uR);
});
;// CONCATENATED MODULE: ./components/styles/StyledInput.tsx

var StyledInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "StyledInput",
  componentId: "sc-bc4pvz-0"
})(["border:none;background:", ";color:", ";border-bottom:1px solid ", ";padding:12px;min-height:40px;font-size:", ";border-radius:4px;border-bottom-left-radius:0px;border-bottom-right-radius:0px;flex:1;:focus{border:none;outline:0;border-bottom:1px solid ", ";}"], function (props) {
  return props.theme.colors.container.tertiary;
}, function (props) {
  return props.theme.colors.text.primary;
}, function (props) {
  return props.theme.colors.container.tertiaryBorder;
}, function (props) {
  return props.theme.fontSize.regular;
}, function (props) {
  return props.theme.colors.text.primary;
});
;// CONCATENATED MODULE: ./components/styles/StyledCard.tsx

var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledCard",
  componentId: "sc-1fhusce-0"
})(["background-color:", ";border:1px solid ", ";border-radius:8px;padding:12px;display:flex;flex-direction:column;align-self:start;width:100%;"], function (props) {
  return props.theme.colors.container.secondary;
}, function (props) {
  return props.theme.colors.container.secondaryBorder;
});
;// CONCATENATED MODULE: ./components/styles/StyledButton.tsx


var StyledButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledButton",
  componentId: "sc-qd4wd2-0"
})(["cursor:pointer;color:", ";background-color:", ";border:none;border-radius:4px;display:flex;padding:10px 24px;width:fit-content;min-height:20px;font-size:", ";font-weight:300;user-select:none;transition:all 0.4s ease;transform:translateY(0px) scale(1);:hover{background-color:", ";}:active{transform:translateY(2px) scale(0.99);}"], function (props) {
  return props.theme.colors.text.secondary;
}, function (props) {
  return props.isDisabled ? "".concat(props.theme.colors.action.primary).concat(constants/* BUTTON_HIGHLIGHT_HEX_OPACITY_SUFFIX */.uR) : props.theme.colors.action.primary;
}, function (props) {
  return props.theme.fontSize.regular;
}, function (props) {
  return props.isDisabled ? "".concat(props.theme.colors.action.primary).concat(constants/* BUTTON_HIGHLIGHT_HEX_OPACITY_SUFFIX */.uR) : props.theme.colors.action.primaryHighlight;
});
;// CONCATENATED MODULE: ./components/styles/StyledScreen.tsx


var StyledScreen = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledScreen",
  componentId: "sc-fjsnv4-0"
})(["display:flex;background-color:", ";min-height:100vh;width:100vw;overflow:hidden;@media (max-width:", "){padding:env(safe-area-inset);height:100vh;min-height:-webkit-fill-available;width:-webkit-fill-available;}"], function (props) {
  return props.theme.colors.container.primary;
}, function (props) {
  return !!props.customBreakpoint ? props.customBreakpoint : constants/* MOBILE_BREAKPOINT */.Gh;
});

;// CONCATENATED MODULE: ./components/styles/ContentContainer.tsx


var ContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContentContainer",
  componentId: "sc-1585o7p-0"
})(["max-width:", ";padding-left:0px;padding-right:0px;padding-top:24px;margin:0px auto;flex:1;display:flex;flex-direction:column;overflow-y:auto;padding-bottom:24px;align-self:center;@media (max-width:", "){width:100%;padding-left:12px;padding-right:12px;align-self:flex-start;}"], function (props) {
  return !!props.customBreakpoint ? props.customBreakpoint : constants/* MOBILE_BREAKPOINT */.Gh;
}, function (props) {
  return !!props.customBreakpoint ? props.customBreakpoint : constants/* MOBILE_BREAKPOINT */.Gh;
});

;// CONCATENATED MODULE: ./components/styles/Row.tsx

var Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Row",
  componentId: "sc-1e0z1v2-0"
})(["display:flex;flex-direction:row;"]);

;// CONCATENATED MODULE: ./components/styles/Column.tsx

var Column = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Column",
  componentId: "sc-6gtkrx-0"
})(["display:flex;flex-direction:column;"]);

;// CONCATENATED MODULE: ./components/styles/StyledCta.tsx


var StyledCta = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "StyledCta",
  componentId: "sc-117up5g-0"
})(["color:", ";font-size:", ";font-weight:400;margin:0px;cursor:pointer;text-decoration:none;user-select:none;:hover{color:", ";text-decoration:underline;}"], function (props) {
  return "".concat(props.theme.colors.text.primary).concat(constants/* CTA_HEX_OPACITY_SUFFIX */.sK);
}, function (props) {
  return props.theme.fontSize.small;
}, function (props) {
  return props.theme.colors.text.primary;
});

;// CONCATENATED MODULE: ./components/styles/index.ts











/***/ }),

/***/ 92909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gh": function() { return /* binding */ MOBILE_BREAKPOINT; },
/* harmony export */   "cA": function() { return /* binding */ BACKGROUND_IMAGE_OPACITY; },
/* harmony export */   "k6": function() { return /* binding */ HAPE_BACKGROUND_IMAGE_URL; },
/* harmony export */   "lh": function() { return /* binding */ TYPEFORM_URL; },
/* harmony export */   "rH": function() { return /* binding */ IS_FORM_CLOSED; },
/* harmony export */   "sK": function() { return /* binding */ CTA_HEX_OPACITY_SUFFIX; },
/* harmony export */   "uR": function() { return /* binding */ BUTTON_HIGHLIGHT_HEX_OPACITY_SUFFIX; },
/* harmony export */   "zZ": function() { return /* binding */ SIGNING_MESSAGE; }
/* harmony export */ });
/* unused harmony export METAMASK_URL */
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25934);

var METAMASK_URL = "https://metamask.io/";
var SIGNING_MESSAGE = ["Crypto forms is requesting your signature to allow you to login.", "We need to do this to prove you are the owner of this wallet.", "Don't worry this will not cost you any ETH", "Generated code for security: ".concat((0,uuid__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)())].join("\n\n");
var BUTTON_HIGHLIGHT_HEX_OPACITY_SUFFIX = "1A";
var CTA_HEX_OPACITY_SUFFIX = "A6";
var BACKGROUND_IMAGE_OPACITY = "CC";
var MOBILE_BREAKPOINT = "771px";
var HAPE_BACKGROUND_IMAGE_URL = "https://images.crypto-forms.io/holding/hapes.jpg";
var TYPEFORM_URL = "https://do3g2v3m76f.typeform.com/to/JUNLNcfn"; // export const IS_FORM_CLOSED = process.env.NEXT_PUBLIC_IS_FORM_CLOSED === "true";

var IS_FORM_CLOSED = true;

/***/ }),

/***/ 69602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_form; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
// EXTERNAL MODULE: ./components/styles/index.ts + 9 modules
var styles = __webpack_require__(38248);
// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(92909);
// EXTERNAL MODULE: ./node_modules/object-hash/dist/object_hash.js
var object_hash = __webpack_require__(40705);
var object_hash_default = /*#__PURE__*/__webpack_require__.n(object_hash);
// EXTERNAL MODULE: ./node_modules/@ethersproject/providers/lib.esm/web3-provider.js + 45 modules
var web3_provider = __webpack_require__(57329);
// EXTERNAL MODULE: ./node_modules/web3modal/dist/index.js
var dist = __webpack_require__(42484);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/@walletconnect/web3-provider/dist/esm/index.js + 38 modules
var esm = __webpack_require__(74845);
// EXTERNAL MODULE: ./node_modules/@coinbase/wallet-sdk/dist/index.js
var wallet_sdk_dist = __webpack_require__(45811);
;// CONCATENATED MODULE: ./hooks/useWeb3Data.ts







var providerOptions = {
  walletlink: {
    "package": wallet_sdk_dist/* default */.ZP,
    options: {
      appName: "web3_forms",
      infuraId: "c6d25a345c8945b08a268d0790461fbb"
    }
  },
  walletconnect: {
    "package": esm/* default */.Z,
    options: {
      infuraId: "c6d25a345c8945b08a268d0790461fbb"
    }
  }
};

var useWeb3Data = function useWeb3Data() {
  var _useState = (0,react.useState)(),
      web3Modal = _useState[0],
      setWeb3Modal = _useState[1];

  var clearWeb3ProviderCache = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return web3Modal === null || web3Modal === void 0 ? void 0 : web3Modal.clearCachedProvider();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function clearWeb3ProviderCache() {
      return _ref.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    setWeb3Modal(new (dist_default())({
      network: "mainnet",
      cacheProvider: false,
      providerOptions: providerOptions
    }));
    return function () {
      clearWeb3ProviderCache();
    };
  }, []);

  var connectWallet = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var instance, provider;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return web3Modal === null || web3Modal === void 0 ? void 0 : web3Modal.connect();

            case 3:
              instance = _context2.sent;
              provider = new web3_provider/* Web3Provider */.Q(instance);
              return _context2.abrupt("return", {
                success: true,
                data: {
                  provider: provider
                }
              });

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              _context2.next = 12;
              return clearWeb3ProviderCache();

            case 12:
              return _context2.abrupt("return", {
                success: false,
                error: "Failed to connect to the ethereum network"
              });

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 8]]);
    }));

    return function connectWallet() {
      return _ref2.apply(this, arguments);
    };
  }();

  var getAccount = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(_ref3) {
      var provider, accounts;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              provider = _ref3.provider;
              _context3.prev = 1;
              _context3.next = 4;
              return provider.listAccounts();

            case 4:
              accounts = _context3.sent;

              if (!((accounts === null || accounts === void 0 ? void 0 : accounts.length) == 0)) {
                _context3.next = 8;
                break;
              }

              clearWeb3ProviderCache();
              return _context3.abrupt("return", {
                success: false,
                error: "No account connected"
              });

            case 8:
              return _context3.abrupt("return", {
                success: true,
                data: {
                  account: accounts[0]
                }
              });

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](1);
              _context3.next = 15;
              return clearWeb3ProviderCache();

            case 15:
              if (!(_context3.t0.message == "User rejected the request.")) {
                _context3.next = 17;
                break;
              }

              return _context3.abrupt("return", {
                success: false,
                error: "User rejected the integration"
              });

            case 17:
              return _context3.abrupt("return", {
                success: false,
                error: "An unknown error occured"
              });

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 11]]);
    }));

    return function getAccount(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  var signMessage = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(_ref5) {
      var provider, message, walletAddress, contentsHash, _provider$provider$re, _provider$provider, signature;

      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              provider = _ref5.provider, message = _ref5.message, walletAddress = _ref5.walletAddress, contentsHash = _ref5.contentsHash;
              _context4.prev = 1;
              _context4.next = 4;
              return provider === null || provider === void 0 ? void 0 : (_provider$provider$re = (_provider$provider = provider.provider).request) === null || _provider$provider$re === void 0 ? void 0 : _provider$provider$re.call(_provider$provider, {
                method: "personal_sign",
                params: [message, walletAddress, contentsHash]
              });

            case 4:
              signature = _context4.sent;
              return _context4.abrupt("return", {
                success: true,
                data: {
                  signature: signature
                }
              });

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](1);
              _context4.next = 12;
              return clearWeb3ProviderCache();

            case 12:
              return _context4.abrupt("return", {
                success: false,
                error: "Signature denied: please sign the signature request when trying again."
              });

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 8]]);
    }));

    return function signMessage(_x2) {
      return _ref6.apply(this, arguments);
    };
  }();

  return {
    connectWallet: connectWallet,
    getAccount: getAccount,
    signMessage: signMessage
  };
};


// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 5 modules
var toConsumableArray = __webpack_require__(76687);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./networking/client.ts

var BASE_URL = "https://api.crypto-forms.io";
var axiosClient = axios_default().create();
axiosClient.defaults.baseURL = BASE_URL;
axiosClient.defaults.headers = {
  "Content-Type": "application/json",
  Accept: "application/json"
};
axiosClient.defaults.timeout = 2000;
axiosClient.defaults.withCredentials = true;
function getRequest(URL) {
  return axiosClient.get("/".concat(URL)).then(function (response) {
    return response;
  });
}
function postRequest(URL, payload) {
  return axiosClient.post("/".concat(URL), payload).then(function (response) {
    return response;
  });
}
;// CONCATENATED MODULE: ./networking/endpoints.ts
var Endpoint = {
  forms: function forms(id) {
    return "forms/".concat(id);
  },
  responses: function responses(id) {
    return "forms/".concat(id, "/responses");
  }
};
;// CONCATENATED MODULE: ./services/formService.ts







var DUPLICATE_SUBMISSION_ERROR_CODE = 409;
var FormService = /*#__PURE__*/(0,createClass/* default */.Z)(function FormService() {
  (0,classCallCheck/* default */.Z)(this, FormService);

  (0,defineProperty/* default */.Z)(this, "fetchForm", /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
      var id, response, responseData, mappedData;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              id = _ref.id;
              _context.prev = 1;
              _context.next = 4;
              return getRequest(Endpoint.forms("".concat(id)));

            case 4:
              response = _context.sent;
              responseData = response.data;
              mappedData = {
                id: responseData.uuid,
                title: responseData.title,
                logoUrl: responseData.logo_url,
                //TODO: Get back end to return this
                description: "After you click submit, make sure you sign with your wallet that holds your HAPE(s), Genesis HAPE or your HAPE Badge(s).",
                questions: responseData.questions.map(function (question) {
                  return {
                    id: question.id,
                    body: question.body,
                    isRequired: true,
                    answer: "",
                    hasError: false
                  };
                })
              };
              return _context.abrupt("return", {
                success: true,
                data: {
                  form: mappedData
                }
              });

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              return _context.abrupt("return", {
                success: false,
                error: "An error occured fetching the form"
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());

  (0,defineProperty/* default */.Z)(this, "submitForm", /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(_ref3) {
      var id, payload, _error$response;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              id = _ref3.id, payload = _ref3.payload;
              _context2.prev = 1;
              _context2.next = 4;
              return postRequest(Endpoint.responses("".concat(id)), {
                auth: {
                  wallet_address: payload.walletAddress,
                  signature: payload.signature,
                  message: payload.message
                },
                hashed_responses: payload.hashedResponses,
                responses: payload.responses.map(function (response) {
                  return {
                    question_id: response.questionId,
                    answer: response.answer
                  };
                })
              });

            case 4:
              return _context2.abrupt("return", {
                success: true
              });

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);

              if (!((_context2.t0 === null || _context2.t0 === void 0 ? void 0 : (_error$response = _context2.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === DUPLICATE_SUBMISSION_ERROR_CODE)) {
                _context2.next = 11;
                break;
              }

              return _context2.abrupt("return", {
                success: false,
                error: "A form has already been submitted with this wallet address: ".concat(payload.walletAddress)
              });

            case 11:
              return _context2.abrupt("return", {
                success: false,
                error: "An error occurred trying to submit your form. Please try again."
              });

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 7]]);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }());
});
;// CONCATENATED MODULE: ./hooks/useGetFormData.ts




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var TIMEOUT_INTERVAL_MS = 3000;

var useGetFormData = function useGetFormData() {
  var formService = new FormService();

  var _useState = (0,react.useState)(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useState2 = (0,react.useState)(),
      data = _useState2[0],
      setData = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      hasError = _useState3[0],
      setHasError = _useState3[1];

  var router = (0,next_router.useRouter)();
  var _ref = router.query,
      formId = _ref.id;

  var fetchForm = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _formDataReponse$data;

      var formDataReponse;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setHasError(false);
              setIsLoading(true);
              _context.next = 4;
              return formService.fetchForm({
                id: formId
              });

            case 4:
              formDataReponse = _context.sent;
              setIsLoading(false);

              if (!formDataReponse.success) {
                setHasError(true);
              }

              setData((_formDataReponse$data = formDataReponse.data) === null || _formDataReponse$data === void 0 ? void 0 : _formDataReponse$data.form);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchForm() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    setIsLoading(true);
    var timer;

    if (!formId) {
      timer = setTimeout(function () {
        // Needed as if the form id url param is not given then the form will load forever
        setIsLoading(false);
        setHasError(true);
      }, TIMEOUT_INTERVAL_MS);
      return;
    }

    (function () {
      return clearTimeout(timer);
    });

    fetchForm();
    return function () {
      return clearTimeout(timer);
    };
  }, [formId]);

  var updateAnswer = function updateAnswer(text, index) {
    var questionsCopy = (0,toConsumableArray/* default */.Z)(data.questions);

    questionsCopy[index].answer = text;
    questionsCopy[index].hasError = false;
    setData(_objectSpread(_objectSpread({}, data), {}, {
      questions: questionsCopy
    }));
  };

  var validate = function validate() {
    var isValid = true;
    var questionCopy = data === null || data === void 0 ? void 0 : data.questions.map(function (question) {
      if (question.answer || !question.isRequired) {
        return _objectSpread(_objectSpread({}, question), {}, {
          hasError: false
        });
      }

      isValid = false;
      return _objectSpread(_objectSpread({}, question), {}, {
        hasError: true
      });
    });
    setData(_objectSpread(_objectSpread({}, data), {}, {
      questions: questionCopy
    }));
    return isValid;
  };

  return {
    data: data,
    hasError: hasError,
    isLoading: isLoading,
    retry: fetchForm,
    updateAnswer: updateAnswer,
    validate: validate
  };
};


;// CONCATENATED MODULE: ./hooks/useFormSubmissionData.ts










var useFormSubmissionData = function useFormSubmissionData() {
  var formService = new FormService();

  var _useState = (0,react.useState)(),
      submissionError = _useState[0],
      setSubmissionError = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = (0,react.useState)(),
      walletAddress = _useState3[0],
      setWalletAddress = _useState3[1];

  var _useWeb3Data = useWeb3Data(),
      connectWallet = _useWeb3Data.connectWallet,
      getAccount = _useWeb3Data.getAccount,
      signMessage = _useWeb3Data.signMessage;

  var _useGetFormData = useGetFormData(),
      data = _useGetFormData.data,
      hasError = _useGetFormData.hasError,
      isLoadingFetchingForm = _useGetFormData.isLoading,
      updateAnswer = _useGetFormData.updateAnswer,
      validate = _useGetFormData.validate;

  var router = (0,next_router.useRouter)();
  var _ref = router.query,
      formId = _ref.id;

  var submitForm = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _accountResponse$data;

      var isConnectedResult, accountResponse, accountAddress, responseDataToHash, formHash, signMessageResponse, formSubmissionResponse;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setSubmissionError(undefined);
              setIsLoading(true);
              _context.next = 4;
              return connectWallet();

            case 4:
              isConnectedResult = _context.sent;

              if (isConnectedResult.success) {
                _context.next = 9;
                break;
              }

              setSubmissionError(isConnectedResult.error);
              setIsLoading(false);
              return _context.abrupt("return", {
                success: false,
                error: isConnectedResult.error
              });

            case 9:
              _context.next = 11;
              return getAccount({
                provider: isConnectedResult.data.provider
              });

            case 11:
              accountResponse = _context.sent;

              if (accountResponse.success) {
                _context.next = 16;
                break;
              }

              setSubmissionError(accountResponse.error);
              setIsLoading(false);
              return _context.abrupt("return", {
                success: false,
                error: accountResponse.error
              });

            case 16:
              accountAddress = (_accountResponse$data = accountResponse.data) === null || _accountResponse$data === void 0 ? void 0 : _accountResponse$data.account;
              setWalletAddress(accountAddress);
              responseDataToHash = data.questions.map(function (question) {
                return {
                  id: question.id,
                  body: question.body,
                  answer: question.answer
                };
              });
              formHash = object_hash_default()(responseDataToHash);
              _context.next = 22;
              return signMessage({
                provider: isConnectedResult.data.provider,
                message: constants/* SIGNING_MESSAGE */.zZ,
                walletAddress: accountAddress,
                contentsHash: formHash
              });

            case 22:
              signMessageResponse = _context.sent;

              if (signMessageResponse.success) {
                _context.next = 27;
                break;
              }

              setSubmissionError(signMessageResponse.error);
              setIsLoading(false);
              return _context.abrupt("return", {
                success: false,
                error: signMessageResponse.error
              });

            case 27:
              _context.next = 29;
              return formService.submitForm({
                id: formId,
                payload: {
                  walletAddress: accountAddress,
                  signature: signMessageResponse.data.signature,
                  message: constants/* SIGNING_MESSAGE */.zZ,
                  hashedResponses: formHash,
                  responses: data.questions.map(function (question) {
                    return {
                      questionId: question.id,
                      answer: question.answer
                    };
                  })
                }
              });

            case 29:
              formSubmissionResponse = _context.sent;

              if (formSubmissionResponse.success) {
                _context.next = 34;
                break;
              }

              setSubmissionError(formSubmissionResponse.error);
              setIsLoading(false);
              return _context.abrupt("return", {
                success: false,
                error: formSubmissionResponse.error
              });

            case 34:
              return _context.abrupt("return", {
                success: true
              });

            case 35:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function submitForm() {
      return _ref2.apply(this, arguments);
    };
  }();

  return {
    data: data,
    updateAnswer: updateAnswer,
    submitForm: submitForm,
    submissionError: submissionError,
    isLoading: isLoading,
    walletAddress: walletAddress,
    validate: validate,
    isFetchingData: isLoadingFetchingForm
  };
};


;// CONCATENATED MODULE: ./routes.ts
var Routes;

(function (Routes) {
  Routes["Landing"] = "/landing.html";
  Routes["FormBuilder"] = "/form_builder.html";
  Routes["Form"] = "/form.html";
})(Routes || (Routes = {}));


// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Error.js
var Error = __webpack_require__(89572);
// EXTERNAL MODULE: ./node_modules/react-loader-spinner/dist/esm/index.js + 26 modules
var dist_esm = __webpack_require__(6470);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CheckCircle.js
var CheckCircle = __webpack_require__(60888);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/screenLoader/screenLoader.tsx





var ScreenLoading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "screenLoader__ScreenLoading",
  componentId: "sc-cfz6y5-0"
})(["display:grid;justify-content:center;align-content:center;height:100%;"]);

var ScreenLoader = function ScreenLoader() {
  var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(styles/* StyledScreen */.x9, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(styles/* ContentContainer */.OO, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ScreenLoading, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist_esm/* Oval */.iT, {
          height: 50,
          width: 50,
          color: theme.colors.action.primary,
          visible: true,
          ariaLabel: "oval-loading",
          secondaryColor: "".concat(theme.colors.action.primary).concat(constants/* BUTTON_HIGHLIGHT_HEX_OPACITY_SUFFIX */.uR),
          strokeWidth: 4,
          strokeWidthSecondary: 4
        })
      })
    })
  });
};


;// CONCATENATED MODULE: ./components/screenLoader/index.ts


;// CONCATENATED MODULE: ./hooks/useIsMounted.ts


var useIsMounted = function useIsMounted() {
  var isMounted = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    if (isMounted.current === false) {
      isMounted.current = true;
    }
  }, []);
  return {
    isMounted: isMounted.current
  };
};


;// CONCATENATED MODULE: ./components/styles/StyledInitialRenderScreen.tsx

var StyledInitialRenderScreen = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledInitialRenderScreen",
  componentId: "sc-1bjna6w-0"
})(["height:100vh;width:100vw;background-color:", ";"], function (props) {
  return props.theme.colors.container.primary;
});
;// CONCATENATED MODULE: ./assets/404-not-found.svg
/* harmony default export */ var _404_not_found = ({"src":"/_next/static/media/404-not-found.7701397b.svg","height":1200,"width":1600});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/form_error/form_error.view.tsx









var CenteredColumn = (0,styled_components_browser_esm/* default */.ZP)(styles/* Column */.sg).withConfig({
  displayName: "form_errorview__CenteredColumn",
  componentId: "sc-1wf856p-0"
})(["margin-top:12px;align-content:center;height:100%;align-items:center;"]);
var CTA = (0,styled_components_browser_esm/* default */.ZP)(styles/* StyledCta */.Bw).withConfig({
  displayName: "form_errorview__CTA",
  componentId: "sc-1wf856p-1"
})(["margin-bottom:140px;@media (max-width:", "){margin-bottom:40px;}"], constants/* MOBILE_BREAKPOINT */.Gh);
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "form_errorview__Title",
  componentId: "sc-1wf856p-2"
})(["font-size:", ";color:", ";margin-top:24px;font-weight:500;text-align:center;"], function (props) {
  return props.theme.fontSize.title;
}, function (props) {
  return props.theme.colors.text.primary;
});
var Body = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "form_errorview__Body",
  componentId: "sc-1wf856p-3"
})(["font-size:", ";color:", ";margin-top:24px;text-align:center;max-width:450px;line-height:25px;"], function (props) {
  return props.theme.fontSize.regular;
}, function (props) {
  return props.theme.colors.text.primary;
});

var FormErrorView = function FormErrorView() {
  var router = (0,next_router.useRouter)();

  var onCTAClick = function onCTAClick() {
    router.push(Routes.Landing);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(styles/* StyledScreen */.x9, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(styles/* ContentContainer */.OO, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CenteredColumn, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CTA, {
          onClick: onCTAClick,
          children: "Powered by Crypto Forms"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: _404_not_found,
          height: 650
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
          children: "Form not found!"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Body, {
          children: "We couldn't find the form you were looking form. Make sure the url is correct and try again."
        })]
      })
    })
  });
};


;// CONCATENATED MODULE: ./components/form_error/index.ts


;// CONCATENATED MODULE: ./pages/form.tsx



















var ImageScreen = (0,styled_components_browser_esm/* default */.ZP)(styles/* StyledScreen */.x9).withConfig({
  displayName: "form__ImageScreen",
  componentId: "sc-1rbl9jk-0"
})(["background:", ";background-color:", ";"], "url(\"".concat(constants/* HAPE_BACKGROUND_IMAGE_URL */.k6, "\") no-repeat center center / cover}"), function (props) {
  return "".concat(props.theme.colors.container.primary);
});
var ScreenGradient = (0,styled_components_browser_esm/* default */.ZP)(styles/* StyledScreen */.x9).withConfig({
  displayName: "form__ScreenGradient",
  componentId: "sc-1rbl9jk-1"
})(["background-color:", ";"], function (props) {
  return "".concat(props.theme.colors.container.primary).concat(constants/* BACKGROUND_IMAGE_OPACITY */.cA);
});
var form_Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "form__Title",
  componentId: "sc-1rbl9jk-2"
})(["color:", ";font-size:", ";font-weight:bold;margin:0px 0px;"], function (props) {
  return props.theme.colors.text.primary;
}, function (props) {
  return props.theme.fontSize.title;
});
var Description = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "form__Description",
  componentId: "sc-1rbl9jk-3"
})(["color:", ";font-size:", ";font-weight:400;margin:4px 0px;margin-top:12px;"], function (props) {
  return props.theme.colors.text.primary;
}, function (props) {
  return props.theme.fontSize.small;
});
var form_CTA = (0,styled_components_browser_esm/* default */.ZP)(styles/* StyledCta */.Bw).withConfig({
  displayName: "form__CTA",
  componentId: "sc-1rbl9jk-4"
})(["margin-top:0px;margin-bottom:24px;align-self:center;"]);
var Column = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "form__Column",
  componentId: "sc-1rbl9jk-5"
})(["display:flex;flex-direction:column;"]);
var Logo = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "form__Logo",
  componentId: "sc-1rbl9jk-6"
})(["width:130px;height:130px;border-radius:8px;object-fit:cover;margin-left:12px;"]);
var TitleRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "form__TitleRow",
  componentId: "sc-1rbl9jk-7"
})(["display:flex;flex-direction:row;align-items:center;justify-content:space-between;"]);
var QuestionTitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "form__QuestionTitleContainer",
  componentId: "sc-1rbl9jk-8"
})(["display:flex;flex-direction:row;"]);
var QuestionTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
  displayName: "form__QuestionTitle",
  componentId: "sc-1rbl9jk-9"
})(["color:", ";margin:6px 0px;font-weight:400;padding:0px 0px;"], function (props) {
  return props.theme.colors.text.primary;
});
var Required = (0,styled_components_browser_esm/* default */.ZP)(QuestionTitle).withConfig({
  displayName: "form__Required",
  componentId: "sc-1rbl9jk-10"
})(["color:", ";margin-left:2px;"], function (props) {
  return props.theme.colors.action.primary;
});
var TitleCard = (0,styled_components_browser_esm/* default */.ZP)(styles/* StyledCard */.rg).withConfig({
  displayName: "form__TitleCard",
  componentId: "sc-1rbl9jk-11"
})(["margin-bottom:12px;width:100%;"]);
var AnswerCard = (0,styled_components_browser_esm/* default */.ZP)(styles/* StyledCard */.rg).withConfig({
  displayName: "form__AnswerCard",
  componentId: "sc-1rbl9jk-12"
})(["margin-bottom:12px;width:100%;"]);
var Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "form__Row",
  componentId: "sc-1rbl9jk-13"
})(["display:flex;flex-direction:row;align-items:center;margin:6px 0px;"]);
var ErrorMessage = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
  displayName: "form__ErrorMessage",
  componentId: "sc-1rbl9jk-14"
})(["font-size:", ";font-weight:400;color:", ";margin:0px;margin-top:12px;margin-left:4px;overflow-wrap:break-word;@media (max-width:", "){overflow-wrap:anywhere;}"], function (props) {
  return props.theme.fontSize.small;
}, function (props) {
  return props.theme.colors.text.error;
}, constants/* MOBILE_BREAKPOINT */.Gh);
var SubmissionErrorMessage = (0,styled_components_browser_esm/* default */.ZP)(ErrorMessage).withConfig({
  displayName: "form__SubmissionErrorMessage",
  componentId: "sc-1rbl9jk-15"
})(["margin:0px;margin-left:8px;"]);
var SuccessMessage = (0,styled_components_browser_esm/* default */.ZP)(QuestionTitle).withConfig({
  displayName: "form__SuccessMessage",
  componentId: "sc-1rbl9jk-16"
})(["margin-left:6px;color:", ";font-size:", ";overflow-wrap:anywhere;"], function (props) {
  return props.theme.colors.text.primary;
}, function (props) {
  return props.theme.fontSize.small;
});

var Form = function Form() {
  var router = (0,next_router.useRouter)();
  var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();

  var _useFormSubmissionDat = useFormSubmissionData(),
      data = _useFormSubmissionDat.data,
      updateAnswer = _useFormSubmissionDat.updateAnswer,
      validate = _useFormSubmissionDat.validate,
      submitForm = _useFormSubmissionDat.submitForm,
      submissionError = _useFormSubmissionDat.submissionError,
      isLoading = _useFormSubmissionDat.isLoading,
      walletAddress = _useFormSubmissionDat.walletAddress,
      isFetchingData = _useFormSubmissionDat.isFetchingData;

  var _useState = (0,react.useState)(false),
      formSubmitted = _useState[0],
      setFormSubmitted = _useState[1];

  var _useIsMounted = useIsMounted(),
      isMounted = _useIsMounted.isMounted;

  var onSubmissionClick = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var isValid, submissionResult;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!isLoading) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              isValid = validate();

              if (isValid) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return");

            case 5:
              _context.next = 7;
              return submitForm();

            case 7:
              submissionResult = _context.sent;

              if (submissionResult.success) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return");

            case 10:
              setFormSubmitted(true);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmissionClick() {
      return _ref.apply(this, arguments);
    };
  }();

  var onAnswerTextChange = function onAnswerTextChange(text, index) {
    updateAnswer(text, index);
  };

  var onCTAClick = function onCTAClick() {
    router.push(Routes.Landing);
  };

  var renderSubmitRow = function renderSubmitRow() {
    if (formSubmitted) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(Column, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Row, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CheckCircle/* default */.Z, {
            fontSize: "medium",
            sx: {
              color: theme.colors.text.success
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessMessage, {
            children: "Form submitted by wallet address: ".concat(walletAddress)
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessMessage, {
          children: "You can now close this window"
        })]
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(Row, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles/* StyledButton */.Sn, {
        isDisabled: isLoading,
        onClick: onSubmissionClick,
        children: "Submit"
      }), isLoading && /*#__PURE__*/(0,jsx_runtime.jsx)(dist_esm/* Oval */.iT, {
        height: 30,
        width: 30,
        wrapperStyle: {
          marginLeft: "8px"
        },
        color: theme.colors.action.primary,
        visible: true,
        ariaLabel: "oval-loading",
        secondaryColor: "".concat(theme.colors.action.primary).concat(constants/* BUTTON_HIGHLIGHT_HEX_OPACITY_SUFFIX */.uR),
        strokeWidth: 4,
        strokeWidthSecondary: 4
      })]
    });
  };

  if (!isMounted) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledInitialRenderScreen, {});
  }

  if (isFetchingData) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ScreenLoader, {});
  }

  if (!data) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(FormErrorView, {});
  }

  var renderHeaderRow = function renderHeaderRow() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(form_CTA, {
        onClick: onCTAClick,
        children: "Powered by Crypto Forms"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TitleCard, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TitleRow, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Column, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(form_Title, {
              children: data.title
            }), data.description && /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
              children: data.description
            })]
          }), data.logoUrl && /*#__PURE__*/(0,jsx_runtime.jsx)(Logo, {
            src: data.logoUrl
          })]
        })
      })]
    });
  }; //TODO: Clean this up and change env variable to response on form api call


  if (constants/* IS_FORM_CLOSED */.rH) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ImageScreen, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ScreenGradient, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(styles/* ContentContainer */.OO, {
          children: [renderHeaderRow(), /*#__PURE__*/(0,jsx_runtime.jsx)(TitleCard, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(QuestionTitle, {
              children: "Form Closed"
            })
          })]
        })
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ImageScreen, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ScreenGradient, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(styles/* ContentContainer */.OO, {
        children: [renderHeaderRow(), data.questions.map(function (question, index) {
          var onTextChange = function onTextChange(event) {
            onAnswerTextChange(event.currentTarget.value, index);
          };

          return /*#__PURE__*/(0,jsx_runtime.jsxs)(AnswerCard, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(QuestionTitleContainer, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(QuestionTitle, {
                children: question.body
              }), question.isRequired && /*#__PURE__*/(0,jsx_runtime.jsx)(Required, {
                children: "*"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles/* StyledInput */.Fy, {
              disabled: isLoading || formSubmitted,
              placeholder: "e.g 0x11r323E29s98a8654qq0D09Dw21bra42cB1lpoDw",
              value: question.answer,
              onChange: onTextChange
            }), question.hasError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
              children: "This field is required"
            })]
          }, question.id);
        }), renderSubmitRow(), submissionError && /*#__PURE__*/(0,jsx_runtime.jsxs)(Row, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Error/* default */.Z, {
            fontSize: "small",
            sx: {
              color: theme.colors.text.error
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubmissionErrorMessage, {
            children: submissionError
          })]
        })]
      })
    })
  });
};

/* harmony default export */ var pages_form = (Form);

/***/ }),

/***/ 13207:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/form",
      function () {
        return __webpack_require__(69602);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36563:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 46601:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 89214:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 85568:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 40127:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 27790:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 69386:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 31616:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 29120:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 46586:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [277,613,46,322,774,888,179], function() { return __webpack_exec__(13207); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);